<script setup lang="ts">
import ToolTip from "../UI/tooltip/ToolTip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useCompanyStore } from "@/stores/company";
import DoughnutChart from "@/components/analysis/DoughnutChart.vue";
import { RiArrowRightSLine, RiInformationLine } from "@remixicon/vue";

const company = useCompanyStore();
const { t } = useI18n();

const companyName = computed(() => {
  if (!company.company.companyName) return;
  return company.company.companyName.length > 12
    ? company.company.companyName.slice(0, 12) + "..."
    : company.company.companyName;
});
</script>
<template>
  <div class="border border-neautrals-200 rounded-md bg-white h-full flex flex-col">
    <div class="flex p-4 items-center justify-between shadow">
      <span class="flex align-center">
        <span class="mr-2">{{ t("dashboard.carbonFootprint") }}</span>
        <ToolTip
          placement="bottom"
          :title="t('dashboard.carbonFootprint')"
          :content="t('dashboard.carbonFootprintToolTip')"
        >
          <RiInformationLine className="w-5 h-5" />
        </ToolTip>
      </span>
      <router-link :to="{ name: 'analysis' }" class="flex">
        <span class="mr-4 underline font-medium">{{
          t("dashboard.goIntoDetail")
        }}</span>
        <RiArrowRightSLine />
      </router-link>
    </div>
    <div class="flex-1 items-center text-center relative">
      <DoughnutChart :company="companyName" :is-limit="true" :limit="20" />
    </div>
  </div>
</template>
